module.exports = __webpack_public_path__ + "img/pc-banner-bg.fa823858.png";